import React from "react";
import './TodosError.css'

function TodosError(){

  return (
    <p className="TodosError__Text">Error, estamos tratando <br/>de solucionarlo</p>
  )
}

export { TodosError };